<template>
    <button
        class="a-delete-button delete-button"
        type="button"
        @click.capture="onClick"
    >
        <svg-icon
            original
            name="icons/delete"
            class="delete-button__icon"
        />
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ADeleteButton',
    props: {
        text: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "a-delete-button";
</style>
